import { Controller } from "@hotwired/stimulus"

export default class AdminPackageFormController extends Controller {
  static targets = ["product", "packageValueLabel", "packageValue"]
  static values = {
    units: Object
  }

  connect() {
    this.showPackageValueLabel()
  }
  
  handlePackageValue() {
    let usageType = this.productTarget.selectedOptions[0].dataset.usageType
    if (usageType === "lifetime") {
      this.packageValueTarget.classList.add('pointer-events-none')
      this.packageValueTarget.value = 9999
    } else {
      this.packageValueTarget.classList.remove('pointer-events-none')
      this.packageValueTarget.value = ''
    }
  }

  showPackageValueLabel() {
    let usageType = this.productTarget.selectedOptions[0].dataset.usageType
    let unitName = this.unitsValue[usageType]
    if(unitName != undefined) {
      this.packageValueLabelTarget.textContent = `ค่า (มีหน่วยเป็น ${unitName})`
    }
  }
}
